// extracted by mini-css-extract-plugin
export var cookieNotice = "cookie-notifier-module--cookieNotice--fd455";
export var message = "cookie-notifier-module--message--69781";